@if (schoolClassData.length) {
<ag-charts [options]="chartOptions">
</ag-charts>
}
